
export default function Card({className='', children }) {
    return (
        <section id="cards-wrapper">
            <div className={`card-section ${className}`}>
                {children}
            </div>
        </section>
    )
}